<div class="view-delta-list-wrapper">
  <div class="table-scroll">
    <table class="bz-table bmc-view-delta__table">
      <thead>
        <tr>
          <th class="bz-table__cell bmc-view-delta__td-center">
            <bzg-checkbox
              [checked]="isAllSelected()"
              [ngModel]="isAllSelected()"
              (ngModelChange)="toggleAll()">
              <!-- Seleccionar todos -->
            </bzg-checkbox>
          </th>
          <th class="bz-table__cell bmc-view-delta__td-left">
            {{ 'VIEW_DELTA.COMPARISON_TYPE' | translate }}
          </th>
          <th class="bz-table__cell bmc-view-delta__td-left">
            {{ 'VIEW_DELTA.OBJECT_TYPE' | translate }}
          </th>
          <th class="bz-table__cell bmc-view-delta__td-left">
            {{ 'VIEW_DELTA.CONTAINED_IN' | translate }}
          </th>
          <th class="bz-table__cell bmc-view-delta__td-left">
            {{ 'VIEW_DELTA.NAME' | translate }}
          </th>
          <th class="bz-table__cell bmc-view-delta__td-center"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paginatedItems; trackBy: trackById">
          <td class="bz-table__cell">
            <bzg-checkbox
              [checked]="isSelected(item)"
              [ngModel]="isSelected(item)"
              (ngModelChange)="toggleItem(item)">
            </bzg-checkbox>
          </td>
          <td class="bz-table__cell">{{ ('VIEW_DELTA.COMPARISON_TYPES.' + item.deltaType.trim().toUpperCase()) | translate }}</td>
          <td class="bz-table__cell">{{ ('OBJECT_TYPES.' + item.objType.trim().toUpperCase()) | translate }}</td>
          <td class="bz-table__cell">{{ item.ancestor }}</td>
          <td class="bz-table__cell">{{ item.displayName || item.name }}</td>
          <td class="bz-table__cell">
            <a *ngIf="(item.deltaType).toString().trim().toLowerCase() === 'update'" class="bmc-view-delta__action-link" (click)="viewChanges(item)" title="{{ 'VIEW_DELTA.VIEW_CHANGES' | translate }}">{{ 'VIEW_DELTA.VIEW_CHANGES' | translate }}</a>
          </td>
        </tr>
        <tr *ngIf="filteredItems && filteredItems.length === 0">
          <td class="bz-table__cell" colspan="6">{{ 'VIEW_DELTA.NO_RESULTS' | translate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="bz-table-pagination paginator-fixed">
    <bzg-paginator 
      [pageIndex]="pageIndex"
      [pageSize]="pageSize" 
      [totalItems]="totalItems" 
      [pageSizeOptions]="[10, 30, 50, 100, 200, 500]"
      [showFirstLastButtons]="true"
      (paginationChanged)="onPaginationEvent($event)">
    </bzg-paginator>
  </div>
</div>